<template>
    <div class="main_unit_calendar">
        <div class="prev_box">
            <div class="box_fix">
                <router-link
                        v-if="canBack"
                        :to="{ name: 'calendar', params: { brandPath: this.brandPath, year: prev.year, month: prev.month }}"><i class="fas fa-chevron-left prev_next_icn"></i><br>
                    前月</router-link>
            </div>
        </div>
        <div class="next_box">
            <div class="box_fix">
                <router-link
                        v-if="canForward"
                        :to="{ name: 'calendar', params: { brandPath: this.brandPath, year: next.year, month: next.month }}"><i class="fas fa-chevron-right prev_next_icn"></i><br>
                    翌月</router-link>
            </div>
        </div>
        <div class="top_unit">
            <div class="top_name_box"><div class="mgb_10">{{brandStoreName}}</div>責任者：{{managerName}}</div>
        </div>
        <div class="top_center_box_mgt pt-4">{{year}}年{{month+1}}月</div>
        <div class="wd840 mgt_30">
            <div class="section">
                <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
                <v-calendar
                        v-show="!isLoading"
                        class="custom-calendar"
                        :masks="masks"
                        :attributes="attributes"
                        disable-page-swipe
                        locale="en"
                        :from-page="{ month: month+1, year: year }"
                >
                    <div
                    slot="day-content"
                    slot-scope="{ day, attributes  }"
                    class="flex flex-col vc-h-full z-10 overflow-hidden"
                    >
                        <router-link :style="attributes == null ? 'pointer-events: none;' : ''" class="d-block vc-w-full vc-h-full text-decoration-none text-dark" :to="{name: 'report', params: {year: year, month: month+1, day: day.day}}">
                            <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
                        </router-link>
                        <div class="h-full">
                            <p
                            v-for="attr in attributes"
                            v-bind:key="attr.key"
                            class="calendar-icons"
                            >
                                <span
                                        v-for="icon in attr.customData.iconClasses"
                                        v-bind:key="icon.key"
                                        class="calendar-icon"
                                        :class="icon.class"
                                >
                            </span>
                            </p>
                        </div>
                    </div>
                </v-calendar>
            </div>
            <div class="btn_submit letter_spa monthly_btn">
                <router-link :to="{name: 'monthlyreport', params: {year: year, month: month+1, day: new Date().getDate()}}">
                    不定期帳票
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    export default {
        components: {
            PulseLoader,
        },
        created() {
            // 年月セット
            this.updateMonth(this.$route.params)
        },
        data: function () {
            return {
                isLoading: true,
                canForward: false,
                canBack: false,
                month: null,
                year: null,
                next: { year: null, month: null },
                prev: { year: null, month: null },
                masks: {
                    weekdays: 'WWW',
                },
                attributes: [],
            };
        },
        computed: {
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            managerName: function () {
                return this.$store.getters['store/adminName']
            },
            brandStoreName: function () {
                let brandName = this.$store.getters['brand/name']
                let storeName = this.$store.getters['store/name']

                if (brandName == null) {
                    brandName = ''
                }

                if (storeName == null) {
                    storeName = ''
                }

                return brandName + '・' + storeName
            },
        },
        mounted () {
            // 報告書一覧取得
            this.fetchReport()
        },
        watch: {
            // ルートが変更されたらこのメソッドを再び呼び出します
            '$route': function () {
                this.updateMonth(this.$route.params)
                this.fetchReport()
            }
        },
        methods: {
            updateMonth: function(params) {
                let now = new Date()
                this.year = params.year ?? now.getFullYear()
                this.month = params.month ? params.month - 1 : now.getMonth()

                this.next.month = (Number(this.month) + 1) % 12 + 1
                this.prev.month = (Number(this.month) + 11) % 12 + 1

                this.prev.year = this.month === 0 ? Number(this.year) - 1 : this.year
                this.next.year = this.month === 11 ? Number(this.year) + 1 : this.year

                this.setCanForward()
                this.setCanBack()
            },
            setCanForward: function () {
                const now = new Date()
                this.canForward = (
                    this.next.year < now.getFullYear())  // 去年のカレンダーはページ送りができる
                    ||  (this.next.year == now.getFullYear() // 今年かつ
                        && this.next.month <= (now.getMonth() + 1)) // 今月までのカレンダーはページ送りできる
            },
            setCanBack: function () {
                const now = new Date()
                const lastYearDate = new Date(now.getFullYear()-1, now.getMonth()) // 昨年の月
                const prevDate = new Date(this.prev.year, this.prev.month-1) // ページ戻しする月
                this.canBack = lastYearDate.getTime() <= prevDate.getTime()
            },
            fetchReport: function () {
                this.isLoading = true
                let brand = this.$store.getters['brand/data']
                let store = this.$store.getters['store/data']
                let url = this.$apiEndpoint+'manage/brand/' + brand.id + '/store/' + store.store_id + '/report/monthly/' + this.year + '/' + (this.month + 1)

                this.$axios.get(url).then(response => {
                    this.attributes = response.data.calendar.data.map(cell => {
                        let highlight = () => {
                            if (cell.storeManagerCommentedFlg) {
                                return {
                                    class: 'custom-calendar-highlight commented',
                                }
                            }
                            else if (cell.confirmedFlg) {
                                return {
                                    color: 'checked-color',
                                    class: 'custom-calendar-highlight checked',

                                }
                            }
                        }

                        const icon = [
                            { kind: 'healthCheck', key: 1, class: 'icon-icn_cl_staff' },
                            { kind: 'dailyCheck', key: 2, class: 'icon-icn_cl_sheet' },
                            { kind: 'cookCheck', key: 3, class: 'icon-icn_cl_yubi' },
                        ]

                        let iconClasses = icon.filter(x => cell.iconDisplayFlg[x.kind] === 1)

                        return {
                            key : cell.id,
                            highlight: highlight(),
                            dates : new Date(cell.date),
                            customData: {
                                iconClasses: iconClasses
                            }
                        }
                    })
                }).catch(err => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}

                    if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }

                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isLoading = false)
            }
        }
    }
</script>

<style lang="css" scoped>
    ::-webkit-scrollbar {
        width: 0px;
    }
    ::-webkit-scrollbar-track {
        display: none;
    }
</style>
